// import external dependencies
import 'jquery';
import 'slick-carousel/slick/slick.min.js';
import 'slick-carousel';
// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


$(".slider-blog").slick({
  slidesToShow: 3,
  speed: 1000,
  slidesToScroll: 1,
  autoplay: true,
  dots: false,
  arrows: true,
  infinite: true,
  responsive: [{
    breakpoint: 768,
    settings: {
      arrows: false,
      slidesToShow: 2,
    },
  },
  {
    breakpoint: 480,
    settings: {
      arrows: false,
      slidesToShow: 1,
    },
  },
  ],
});

$(".clients").slick({
  slidesToShow: 4,
  speed: 1000,
  slidesToScroll: 1,
  autoplay: true,
  dots: false,
  arrows: false,
  infinite: true,
  responsive: [{
    breakpoint: 768,
    settings: {
      arrows: false,
      slidesToShow: 2,
    },
  },
  {
    breakpoint: 480,
    settings: {
      arrows: false,
      slidesToShow: 1,
    },
  },
  ],
});



// WEBPACK FOOTER //
// ./scripts/main.js